module.exports = __webpack_public_path__ + "static/img/jp3.0c973945.png";